export default __webpack_public_path__ + "static/media/bycoders_.a2e16d90.svg";